import { NodeSelection, Plugin, PluginKey } from '@tiptap/pm/state';
import type { EditorView } from '@tiptap/pm/view';

import {
  ALL_TEMPLATE_FIELD_NAMES,
  TEMPLATE_FIELD_DROPDOWN_NAME,
  templateFieldWrapperClass,
} from '../../doc-engine/templateFields';
import { isFieldInCard } from '../nodes/formField/formFieldHelpers';

// The field ProseMirror would drag alone: the selected field the drag starts on, or the Dropdown under it.
const findDraggedFieldPos = (view: EditorView, target: Node): number | undefined => {
  const { selection } = view.state;
  if (
    selection instanceof NodeSelection &&
    ALL_TEMPLATE_FIELD_NAMES.has(selection.node.type.name) &&
    view.nodeDOM(selection.from)?.contains(target)
  ) {
    return selection.from;
  }
  // A drag over selected text starts on its Text node, which has no `closest`.
  const element = target instanceof Element ? target : target.parentElement;
  const dropdown = element?.closest(`.${templateFieldWrapperClass(TEMPLATE_FIELD_DROPDOWN_NAME)}`);
  return dropdown ? view.posAtDOM(dropdown, 0) : undefined;
};

/** Keeps a card's field from being dragged out alone; the card moves by the margin's handle and selected answer text drags. */
const getFormFieldDragGuardPlugin = (): Plugin =>
  new Plugin({
    key: new PluginKey('formFieldDragGuard'),
    props: {
      handleDOMEvents: {
        dragstart: (view, event) => {
          const pos = findDraggedFieldPos(view, event.target as Node);
          if (pos === undefined || !isFieldInCard(view.state.doc, pos)) return false;
          event.preventDefault();
          return true;
        },
      },
    },
  });

export default getFormFieldDragGuardPlugin;
